<script lang="ts">
  export let question: string;
  export let responses: (string | string[])[];
  import Vega from './Vega.svelte';

  const counts = responses.reduce((acc, row) => {
    acc[`${row}`] = (acc[`${row}`] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);
  const hasDuplicates = !Object.values(counts).every((x) => x === 1);

  const example = {
    $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
    data: {
      values: responses.map((x) => ({question: `${x}`}))
    },
    mark: 'bar',
    encoding: {
      x: {aggregate: 'count'},
      y: {field: 'question', type: 'nominal', sort: '-x'}
    }
  };

  let showAsChart = hasDuplicates;
</script>

<div class="flex flex-col my-4 max-w-3xl w-3xl px-8">
  <h5 class="text-bold">Question: {question}</h5>
  {#if showAsChart}
    <Vega spec={example} />
  {:else}
    <ul class="list-disc">
      {#each responses as response}
        <li class="my-2">
          {response}
        </li>
      {/each}
    </ul>
  {/if}
  <button
    class="border-2 cursor-pointer"
    on:click={() => {
      showAsChart = !showAsChart;
    }}>toggle display type</button
  >
</div>
